import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  FilterPreset,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterScope,
  SortOption,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.search}search/filter`;

export type FilterFacetValue =
  | {
      name?: string;
      label?: string;
      included: boolean;
    }
  | {
      minValue: string;
      maxValue: string;
    };

export interface FilterFacet {
  name?: string;
  facets?: FilterFacetValue[];
}

export interface ViewColumn {
  visible: boolean;
  name: string;
}

export interface SetFiltersPresetArgs {
  id: string;
  name?: string;
  tenantId: string;
  creatorId?: string;
  profiles?: string[];
  roles?: string[];
  filters?: FilterFacet[];
  numericFilters?: unknown;
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
  groupedFilters?: GroupedSearchFilterFacet[];
  sortOptions?: SortOption[];
  orderedColumns?: ViewColumn[];
  deletedBy?: string;
  isFavorite?: boolean;
  scope?: SearchFilterScope;
}

export async function upsertFilterCommand(
  filterPreset: SetFiltersPresetArgs,
): Promise<BackResponse<FilterPreset> | BackResponseFailure> {
  try {
    return await apiCall<BackResponse<FilterPreset>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        filter: filterPreset,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
